import React, {useState, useEffect} from 'react'
import { Line } from 'react-chartjs-2';

function TotalIncome({getDateFormat, statistics}) {
    const [stats, setStats] = useState([])
    useEffect(() => {
        let timestamps = [];
        let totalGains = [];
        for (let i=0; i<statistics.length; i++) {
            timestamps.push(statistics[i].timestamp);
            totalGains.push(statistics[i].totalMoney);
        }

        timestamps = getProperTimestamps(timestamps);
        setStats({
            timestamp: timestamps,
            totalMoney: totalGains
        })
    }, [])

    let getProperTimestamps = (timestamps) => {

       let arr = [];
        timestamps.map((timestamp) => {
            arr.push(new Date(timestamp*1000).toLocaleDateString("en-GB"));
        })
        return arr;
    }

    let getData = (stats) => {
        return {
            labels: stats.timestamp,
            datasets: [
                {
                    label: (window.location.href.includes('/en')) ? 'Current Income' : 'הכנסה כוללת',
                    data: stats.totalMoney,
                    backgroundColor: ['rgba(255,104,0,0.6)'],
                    borderWidth: 1,
                    borderColor: '#000'
                }
            ]
        }
    }
    return (
        <div className="chartText">
                {(window.location.href.includes('/en')) ?  <div className="titleChart">Since the website was launched - Now</div>
                : <div className="titleChart">מאז שהאתר הוקם - עכשיו</div>}

                <div className="containerBar">
                    <Line
                    data={getData(stats)}                       
                    options={{ 
                        legend: {
                            display: false,
                        },
                        responsive: true,
                        maintainAspectRatio: false }}
                    />
                </div>


            
        </div>
    )
}

export default TotalIncome
